import axios from '../../axios'
import Axios, { AxiosRequestConfig } from 'axios'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { toast } from 'react-toastify'
import { Role, User } from './types'

export class RolesStore {
  loadingList: boolean = false
  deleting: boolean = false
  list: Role[] = []
  entries: {
    [key: string]: Role
  } = {}
  totalPages: number = 0
  totalElements: number = 0
  cancelTokenSource = () => {}

  constructor() {
    makeObservable(this, {
      loadingList: observable,
      deleting: observable,
      list: observable,
      entries: observable,
      totalPages: observable,
      totalElements: observable,
      getData: action,
      delete: action,
      setRole: action,
      reset: action,
      clearList: action,
      removeFromList: action,
      setLoadingList: action,
    })
  }

  reset = () => {
    this.clearList()
    this.deleting = false
    this.entries = {}
    this.cancelTokenSource = () => {}
  }

  clearList = () => {
    this.loadingList = false
    this.list = []
    this.totalPages = 0
    this.totalElements = 0
  }

  setLoadingList = (value: boolean) => {
    this.loadingList = value
  }

  removeFromList = (id: number) => {
    this.list = this.list.filter((item) => item.id !== id)
  }

  create = async (data: object) => {
    return await axios
      .post('/management/api/v1/role', data)
      .then((response) => {
        toast.success('Created successfully')
        return response
      })
  }

  update = async (id: number, data: object) => {
    return await axios
      .put('/management/api/v1/role/' + id, data)
      .then((response) => {
        toast.success('Updated successfully')
        return response
      })
  }

  delete = async (id: number) => {
    this.deleting = true
    await axios
      .delete('/management/api/v1/role/' + id)
      .then(({ data }) => {
        toast.success('Deleted successfully')
        this.removeFromList(id)
      })
      .finally(() => {
        this.deleting = false
      })
  }

  getById = async (id: number) => {
    return await axios(`/management/api/v1/role/${id}?includeUsers=true`).then(
      ({ data }) => {
        this.setRole(data)
        return data
      }
    )
  }

  getData = (filters: any = {}) => {
    if (typeof this.cancelTokenSource == 'function') {
      // this.cancelTokenSource()
    }
    const cancelTokenSource = Axios.CancelToken.source()

    const params: any = {
      ...filters,
      name: filters.searchValue,
    }
    delete params.searchValue

    this.setLoadingList(true)

    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
      params,
    }
    axios
      .get(`/management/api/v1/role`, config)
      .then(({ data }) => {
        if (data?.content) {
          runInAction(() => {
            this.list = data.content
            this.totalPages = data.totalPages
            this.totalElements = data.totalElements
            this.list.forEach((item) => (this.entries[`${item.id}`] = item))
          })
        }
      })
      .catch(() => {
        this.clearList()
      })
      .finally(() => {
        this.setLoadingList(false)
      })

    this.cancelTokenSource = cancelTokenSource.cancel
  }

  setRole = (folder: Role) => {
    const index = this.list.findIndex((item: Role) => item.id === folder.id)
    if (index !== -1) {
      this.list[index] = folder
    }
    this.entries[`${folder.id}`] = folder
  }

  searchRoles = async (searchValue: string, cancelTokenSource?: any) => {
    const { data } = await axios.get(
      `/management/api/v1/role?name=${encodeURIComponent(
        searchValue
      )}&size=${25}`,
      {
        // @ts-ignore
        cancelTokenSource,
      }
    )
    return data.content as Role[]
  }

  updateRoleUsers = async (id: number, data: { newUsers: User[]; removedUsers: User[]}) => {
    return await axios
      .put(`/management/api/v1/role/${id}/users`, data)
      .then((response) => {
        toast.success('Role users updated successfully')
        return response
      })
  }
}

export const rolesStore = new RolesStore()
